import { API } from 'core/api';

export const pageAPI = {
  fetchByName: (name: string, lang: string) => {
    return API.fetch('page/' + name, lang);
  },
};
